export default "__VITE_ASSET__CHayYA4J__"